import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.628 9.854 4.827 6.51c-.14-.15-.083-.354.126-.455A.589.589 0 0 1 5.206 6h5.588c.252 0 .456.147.456.328a.268.268 0 0 1-.076.182L8.386 9.854c-.14.15-.422.191-.632.09a.418.418 0 0 1-.126-.09Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ArrowSmallDownIcon16.js.map